import { asLink, isFilled } from "@prismicio/helpers"
import { PrismicRichText } from "@prismicio/react"
import type { ColorField, KeyTextField, LinkField, RichTextField } from "@prismicio/types"
import type { CSSProperties, HTMLAttributes } from "react"

import { cn } from "../../ui"
import { CategoryTag } from "../DesktopNavMenu/Index"
import { Link } from "../Link/Link"

export interface SubCategoryStyle extends CSSProperties {
    "--text-color": string
}
export const CategoryText = ({ field }: { field: RichTextField }) => {
    return (
        <PrismicRichText
            field={field}
            components={{
                heading1: ({ children }) => <>{children}</>,
                heading2: ({ children }) => <>{children}</>,
                heading3: ({ children }) => <>{children}</>,
                heading4: ({ children }) => <>{children}</>,
                heading5: ({ children }) => <>{children}</>,
                heading6: ({ children }) => <>{children}</>,
                paragraph: ({ children }) => <>{children}</>,
                strong: ({ children }) => <strong>{children}</strong>,
                em: ({ children }) => <i>{children}</i>,
            }}
        />
    )
}

export const SidebarGroupTitle = ({
    titleField,
    className,
    ...props
}: HTMLAttributes<HTMLDivElement> & { titleField: RichTextField }) => (
    <div {...props} className={cn("uppercase", className)}>
        <CategoryText field={titleField} />
    </div>
)

export const SidebarGroupList = ({ className, ...props }: HTMLAttributes<HTMLUListElement>) => (
    <ul {...props} className={cn("mb-10", className)} />
)
interface PrismicSubCategoryItem {
    subcategory_url: LinkField
    subcategory_color: ColorField
    subcategory_label_text: KeyTextField
    subcategory_label_text_color: ColorField
    subcategory_label_bg_color: ColorField
    product_type: RichTextField
}
export const SidebarGroupItem = ({
    item,
    hoverUnderline,
    ...props
}: HTMLAttributes<HTMLLIElement> & { item: PrismicSubCategoryItem; hoverUnderline: boolean }) => {
    if (!isFilled.link(item.subcategory_url)) return <></>
    const style: SubCategoryStyle = { "--text-color": item.subcategory_color || "inherit" }
    return (
        <li {...props}>
            <Link className="inline-flex items-center" href={asLink(item.subcategory_url)!} style={style}>
                <p
                    className={cn(
                        "text-[var(--text-color)] hover:text-[var(--category-nav-hover-color)]",
                        hoverUnderline ? "hover:underline" : ""
                    )}>
                    <CategoryText field={item.product_type} />
                </p>
                <CategoryTag
                    className="text-tag"
                    label={item.subcategory_label_text || ""}
                    color={item.subcategory_label_text_color || ""}
                    backgroundColor={item.subcategory_label_bg_color || ""}
                />
            </Link>
        </li>
    )
}
